export default __webpack_public_path__ + "static/media/WheatBg.896cdc0d.jpg";